import { memo, useState } from 'react';
import { Tour } from '../../../../_models/Tour';
import AboutPopup from '../popups/About';
import { dLog } from '@/_helpers/renderDebug';

interface IHeaderProps {
  tour: Tour;
  logoUrl: string;
  chatToken: string;
  translation: any;
}

const Header = ({ tour, logoUrl, chatToken, translation }: IHeaderProps) => {
  dLog('Header');
  const [aboutPopupOn, setAboutPopupOn] = useState(false);

  if (tour.client && tour.client.logo && chatToken) return null;

  return (
    <>
      <AboutPopup
        show={aboutPopupOn}
        rtl={tour.client && tour.client.rtl}
        translation={translation}
        description={tour.summary}
        socials={{
          facebook: tour.client && tour.client.facebook,
          instagram: tour.client && tour.client.instagram,
          twitter: tour.client && tour.client.twitter,
          linkedin: tour.client && tour.client.linkedin,
        }}
        logo={logoUrl}
        toggleAboutPopup={() => setAboutPopupOn(false)}
      />
    </>
  );
};

export default memo(Header);
